export default "__VITE_PUBLIC_ASSET__92d65369__"